/* src/app/private/components/tickets/ticket-card-view/ticket-card-view.component.scss */
.sticky-top-bar {
  background-color: var(--p-card-background);
}
.ticket-left-container {
  padding-right: 10px !important;
  overflow-y: auto !important;
}
.ticket-left-container::-webkit-scrollbar {
  width: 8px !important;
}
.ticket-left-container::-webkit-scrollbar-thumb {
  background-color: var(--secondry-light-gray) !important;
  border-radius: 20px !important;
}
.ticket-left-container::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.ticket-left-container-card {
  padding-right: 0px !important;
}
.ticket-left-container-card .p-card-body {
  padding-right: 0px !important;
}
.p-card-body {
  padding-right: 0px !important;
}
.ticket-chip {
  padding: 0.2rem 0.5rem;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
  font-size: 0.875rem;
}
.ticket-card {
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2509803922);
  cursor: pointer;
}
.active-card {
  background-color: var(--minimalistic-background);
  border-color: var(--primary-color);
}
.filter-icon-container {
  background: var(--primary-color);
  color: #fff;
  width: 30px;
  text-align: center;
  padding: 10px;
  font-size: 5px;
  display: flex;
  justify-content: center;
  border-radius: 35px;
  padding: 7px 25px;
  position: absolute;
  top: -4px;
  right: 2px;
}
/*# sourceMappingURL=ticket-card-view.component.css.map */
